import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Observer } from 'gsap/Observer'
import { SplitText } from 'gsap/SplitText'
import { useGSAP } from '@gsap/react'

gsap.registerPlugin(ScrollTrigger, Observer, SplitText, useGSAP)

// Every ScrollTrigger.refresh() re-applies its scroll-memory mode to
// history.scrollRestoration, and the default is "auto" — which lets the
// browser restore old scroll positions on back/forward, landing returning
// visitors mid-page and skipping the scroll-driven hero beats. Keep it
// "manual" so every page visit starts at the top (Root scrolls to 0).
ScrollTrigger.clearScrollMemory('manual')

export { gsap, ScrollTrigger, Observer, SplitText, useGSAP }
